const configuration = {
  apiURL: 'https://api.venturz.co/v1',
  cdnAddress: 'https://cdn.venturz.co'
};

export default Object.seal(configuration);